enum UniverseCreator {
  User = 'User',
  Group = 'Group',
  Team = 'Team',
}

export default UniverseCreator;
